export default __webpack_public_path__ + "static/media/ls.83c83ca5.svg";